import { HOTSPRING_LINK } from "@/env.ts";
import { cn } from "@/lib/utils";
import React from "react";

export const FooterLinks: React.FC<{ className?: string }> = ({
  className,
}) => {
  return (
    <div
      className={cn(
        "flex justify-between text-sm text-[#9a9a9a] gap-2",
        className,
      )}
    >
      <a
        href={HOTSPRING_LINK}
        className="hover:!text-service-paint"
        target="_blank"
        rel="noopener noreferrer"
      >
        thehotspring.com
      </a>
      <a
        href="https://thehotspring.zendesk.com/hc/en-us"
        className="hover:!text-service-paint"
        target="_blank"
        rel="noopener noreferrer"
      >
        Support
      </a>
      <a
        href={`${HOTSPRING_LINK}/legal/`}
        className="hover:!text-service-paint"
        target="_blank"
        rel="noopener noreferrer"
      >
        Terms
      </a>
      <a
        href={`${HOTSPRING_LINK}/privacy-policy/`}
        className="hover:!text-service-paint"
        target="_blank"
        rel="noopener noreferrer"
      >
        Privacy
      </a>
      <a
        href="https://classic.thehotspring.com/docs/"
        className="hover:!text-service-paint whitespace-nowrap"
        target="_blank"
        rel="noopener noreferrer"
      >
        Developers & API
      </a>
    </div>
  );
};
